import s from "./item.module.css";
import {Fragment, h} from "preact";
import {nadWhiteArrow} from "../../../../../../../../assets";
import {useItem} from "./useItem";
import {StoreInfoModal} from "../../../../../../../index";
import {useAppContext} from "../../../../../../../../contexts";

const Item = (props) => {
    // Destructured props
    const {
        item,
        handleChange,
        selectedValue
    } = props;

    // Component logic data
    const componentProps = useItem();

    // Destructured component logic data
    const {
        isModalOpen,
        handleModal
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Validates whether the list items should be displayed or not
    const shouldDisplay = typeof selectedValue.id === "undefined" ?
        "flex" :
        (selectedValue.id && selectedValue.id !== item.id) ?
            "hidden" :
            "flex";

    // The "Saiba +" button
    const infoButton = !item?.externalId ? null : (
        <button
            type={"button"}
            className={s.infoButton}
            onClick={() => handleModal(!isModalOpen)}
        >
            Saiba +
        </button>
    );

    return (
        <Fragment>
            <StoreInfoModal
                externalId={item.externalId}
                storeName={item.label}
                isOpen={isModalOpen}
                setIsOpen={handleModal}
            />

            {/* Main */}
            <li className={`${s.root} ${shouldDisplay}`}>
                {/* Main block */}
                <div className={"w-full text-left text-base flex flex-row justify-between items-center"}>
                    <button
                        type="button"
                        className={`${s.store} ${highContrast ? "text-white" : "text-black"}`}
                        onClick={() => handleChange({
                            id: item.id,
                            label: item.label,
                            stockQty: item?.stockQty || undefined
                        })}
                    >
                        <input
                            type={"radio"}
                            name={"attendance-types"}
                            checked={selectedValue.id === item.id}
                            data-testid="attendance-picker-input"
                        />
                        {item.label}
                    </button>
                    {infoButton}
                </div>

                {/* Action block */}
                <div className={`w-full mb-3 flex flex-col gap-y-4 ${(selectedValue.id !== item.id ? "hidden" : "")}`}>
                    <button
                        type={"submit"}
                        className={`${s.submitButton} ${highContrast ? s.highContrastButton : "text-white"}`}
                    >
                        Adicionar ao carrinho
                        <img
                            src={nadWhiteArrow}
                            className={s.whiteArrow}
                            alt={"White arrow"}
                        />
                    </button>
                    <button
                        type={"button"}
                        className={s.goBackButton}
                        onClick={() => handleChange({
                            id: undefined,
                            label: undefined,
                            stockQty: undefined
                        })}
                    >
                        <img
                            src={nadWhiteArrow}
                            className={s.blackArrow}
                            alt={"Black arrow"}
                        />
                        Escolher outro local
                    </button>
                </div>
            </li>
        </Fragment>
    )
}

export default Item;
